(function () {
    'use strict';

    angular
        .module('directives.oddMaxNumber', [])
        .directive('oddMaxNumber', directive);

    directive.$inject = ['$compile'];

    function directive($compile) {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs) {
                var maxNumber = Number(attrs.oddMaxNumber);
                var max = 1000000000000000; // Max Safe Integer

                // Number('') returns 0, consider it NaN
                if (attrs.oddMaxNumber.length === 0) {
                    maxNumber = Number.NaN;
                }

                if (!isNaN(maxNumber)) {
                    max = maxNumber;
                }

                elem.removeAttr('odd-max-number');
                elem.attr('max', max);
                elem.attr('ng-max', max);
                $compile(elem)(scope);
            }
        }
    }
})();